/**
 * Share-line copy — the Profile's shares-as-speech text (Decided Design #3/#4;
 * open-exchange amendment 2026-07-17: no words in ANYONE's mouth — a single
 * share is just the linked value, no "My number is" sentence). One
 * construction site shared by the chat bubble (ShareLineBubble) and the list
 * previews (formatMessagePreview) so the two can't drift.
 *
 * Icon-free on purpose: list pages import this, and the icon registry
 * (contactTypeConfig) pulls in every Phosphor icon.
 */

import { formatPhoneNumber } from './formatters';
import { getBaseType } from './contactKeys';

const AT_PREFIX_TYPES = ['instagram', 'tiktok', 'twitter'];
const PHONE_LIKE_TYPES = ['phone', 'whatsapp'];

// The multi-select line — one fully-linked phrase (device pass 9)
export const SHARE_LINE_CONTACT_TEXT = 'My contact';

/**
 * The linked display value for a single-channel share line. The whole line IS
 * the value — "@brilarsen", "212-555-1212" — phones formatted, handles
 * @-decorated (matching what the Anon side types since the @ pre-fill).
 */
export const shareLineValue = (shareType, shareValue) => {
  const base = getBaseType(shareType);
  if (PHONE_LIKE_TYPES.includes(base)) return formatPhoneNumber(shareValue);
  if (AT_PREFIX_TYPES.includes(base)) return `@${(shareValue || '').replace(/^@/, '')}`;
  return shareValue;
};

/** Full plain-text line (previews, accessibility). */
export const shareLineText = (message) => {
  if (message.contactLink) return SHARE_LINE_CONTACT_TEXT;
  return shareLineValue(message.shareType, message.shareValue);
};
